export const DISPLAY_DATE_FORMAT = 'dd MMM yyyy'
export const DISPLAY_DATETIME_FORMAT = 'dd MMM yyyy hh:mm a'
export const DEFAULT_SPRITE_PATH = '/assets/icons/icons.svg'
export const INTERNAL_DATETIME_FORMAT = 'yyyy-MM-dd HH:MM'
export const INTERNAL_DATE_FORMAT = 'yyyy-MM-dd'
